import * as Yup from "yup";
import "yup-phone";

export const AdminSchema = Yup.object({
  firstName: Yup.string().min(3,"First Name must be at least 3 characters.").max(50, 'First Name must be at most 50 characters.').matches(/^[a-zA-Z]+(?:\s+[a-zA-Z]+)*$/,"First Name is invalid.").required("First Name cannot be blank."),
  lastName: Yup.string().min(3, "Last Name must be at least 3 characters.").max(50, 'Last Name must be at most 50 characters.').matches(/^[a-zA-Z]+(?:\s+[a-zA-Z]+)*$/,"Last Name is invalid.").required("Last Name cannot be blank."),
  email: Yup.string().email("Email is not valid.").max(255).required("Email cannot be blank."),
  //mobile: Yup.string().phone().required("Mobile Number cannot be blank"),
  username: Yup.string()
              .min(3 ,"Username must be at least 3 characters.")
              .max(255, "Username must be at most 255 characters.")
              .matches(
                /^[0-9a-zA-Z]+([0-9a-zA-Z]*[-._+])*[0-9a-zA-Z]+(@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*([0-9a-zA-Z]*[.])[a-zA-Z]{2,6})?$/,
                "Username is invalid."
              ).required("Username cannot be blank."),
  password: Yup.string()
              .min(8, "Password must be at least 8 characters.")
              .max(100, "Password must be at most 100 characters.")
              .matches(/^[\S]*$/, "Password cannot contain spaces.")
              .required("Password cannot be blank."),
  confirmPassword: Yup.string().required("Confirm Password cannot be blank.").when("password", {
    is: (val) => (val && val.length > 0 ? true : false),
    then: Yup.string().oneOf(
      [Yup.ref("password")],
      "Password doesn't match."
    ),
  }),
  signatureText: Yup.string()
    .max(50, "Signature Text must be at most 50 characters.").nullable(),
    capacity: Yup.number()
    .min(1, "Capacity should be greater than 0!"),

  technicianContactList: Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .min(3, "Name must be at least 3 characters.")
          .max(50, "Name must be at most 50 characters.")
          .required("Name cannot be blank.")
      })
    )
});
